import { useEffect } from 'react';
import { Platform } from 'react-native';
import VerifyEmailHeader from './Header/Header';
import Button from '../../sharedComponents/Button/Button';
import ROUTE from '../../navigationApp/routes';
import GoogleLogin from 'react-google-login';
import EmailIcon from '../../../assets/Icons/Email';
import { GoogleSignin } from '@react-native-google-signin/google-signin';
import GoogleIcon from '../../../assets/Icons/GoogleIcon';
import { endpoints } from '../../api/apis';
import axios from 'axios';
import { updateUserDetails } from '../../store/slices/authSlice';
import { themeColorSet, ThemedText, ThemedView } from '../../theme';
import { NativeStackScreenProps } from '@react-navigation/native-stack';
import { PrivateStackParamList } from '@routes/types';
import ScreenWrapper from '@hoc/ScreenWrapper';
import { trackEvent } from '../../utils/amplitude';
import { useAppDispatch , useAppSelector } from '../../store/hooks';
import { showErrorSheet } from '@app/store/slices/errorSlice';
import { checkColor } from '@app/utils';


const clientID =
  '62646021413-queb1g13go0snvnotl0ee06t68jcgb98.apps.googleusercontent.com';

const GoogleButton = props => {
  return (
    <Button
      eventName='VERIFY_EMAIL_WITH_GOOGLE'
      size='MD'
      type="OUTLINED"
      label="Continue with Google"
      handlePress={props?.onPress}
      showLeftAccessory
      leftAccessory={() => {
        return <GoogleIcon />;
      }}
    />
  );
};


type ScreenProps = NativeStackScreenProps<PrivateStackParamList , 'VERIFY_EMAIL'>

const VerifyEmail = ({ navigation, route } : ScreenProps) => {
  const { userDetails } = useAppSelector(state => state.auth);
  const dispatch = useAppDispatch();
  const gotoVerifyEmail = () => {
    navigation.navigate(ROUTE.ENTER_EMAIL);
  };

  let isDarkMode: boolean | null = null;
  if (Platform.OS === 'web') {
    const params = new URLSearchParams(window.location.search);
    isDarkMode = params.get('isDarkMode') === 'true';
  }


  useEffect(() => {
    if (Platform.OS !== 'web') {
      GoogleSignin.configure({});
    }
  }, []);

  const mobileSignIn = async () => {
    try {
      // Logging out before login so that user gets to see the email options
      await GoogleSignin.signOut()
      await GoogleSignin.hasPlayServices();
      const userInfo = await GoogleSignin.signIn();
      await onResponse(userInfo);
    } catch (error) {
      console.warn('Google error-> ', error);
    }
  };

  const updateUserEmail = (emailId: string) => {
    const userAccountId = userDetails?.linkedApplications[0]?.accountId;
    const payload = {
      secureDataAttributeDetailsMap: {
        EMAIL: {
          secureDataAttributeDetails: {
            value: emailId,
            sources: ['SELF'],
            verified: true,
            verificationSources: ['GOOGLE_AUTH'],
            collectedOn: `${Date.now()}`,
            verifiedOn: `${Date.now()}`,
          },
          isPrimary: true,
        },
      },
    };
    const url = endpoints.accountAttributes + userAccountId;
    axios
      .patch(url, payload, { handleFromMF: true })
      .then(res => {
        dispatch(updateUserDetails(res.data));
        navigation.navigate(ROUTE.KYC_PAN_VERIFICATION);
      })
      .catch(err => {
        dispatch(
          showErrorSheet({
            isErrorSheetVisible : true,
            errorMessage: err?.data?.message,
            closeOnBackdropPress: true,
            errorType: err?.data?.voltErrorCode || err?.data?.statusCode,
            routeName: route?.name
          }),
        );
      });
  };

  const onResponse = response => {
    if(response.error){
      return
    }
    const googleRecievedEmailId = Platform.select({
      native: response?.user?.email,
      default: response?.profileObj?.email,
    });
    trackEvent('EMAIL_VERIFIED' , {email :googleRecievedEmailId })
    updateUserEmail(googleRecievedEmailId);
  };
  return (
    <ScreenWrapper screenName={route?.name} additionalProperties={{newArchRoute : true}}>
      <VerifyEmailHeader pageName={route?.name} navigation={navigation} />
      <ThemedView
       flex={1}
       bg='bg-surface-primary'
       padding='lg'
       >
        <ThemedText variant='h4b' color='text-primary'>Verify your email</ThemedText>
        <ThemedView mt='xs' mb='4xl' >
          <ThemedText variant='b3r' color='text-secondary'>We’ll use this to send important updates.</ThemedText>
        </ThemedView>
        <ThemedView mb='xl'>
          {Platform.OS === 'web' ? (
            <GoogleLogin
              clientId={clientID}
              render={renderProps => (
                <GoogleButton onPress={renderProps.onClick} />
              )}
              buttonText="Login"
              onSuccess={onResponse}
              onFailure={onResponse}
              cookiePolicy={'single_host_origin'}
              isSignedIn={false}
            />
          ) : (
            <GoogleButton onPress={mobileSignIn} />
          )}
        </ThemedView>
        <Button
          eventName={'VERIFY_EMAIL_CONTINUE_WITH_OTHER_EMAIL_CLICKED'}
          size='MD'
          type="OUTLINED"
          label="Continue with other email"
          handlePress={gotoVerifyEmail}
          showLeftAccessory
          leftAccessory={() => {
            return <EmailIcon  bgColor={themeColorSet['bg-fill-emphasis-primary-1']} color={themeColorSet['icon-action-primary']}/>;
          }}
        />
      </ThemedView>
    </ScreenWrapper>
  );
};

export default VerifyEmail;
